import request from '@api/request'

// 专员列表
export const entUserList = params => request.get('/entVisit/entUserList', { params })

// 走访列表
export const visitList = params => request.get('/entVisit/visitList', { params })

// 获取当前专员信息
export const getUserDetail = params => request.get('/organization/user/getUserDetail', { params })

// 新增走访
export const addVisit = params => request.post('/entVisit/addVisit', params)

// 走访详情
export const visitDetail = params => request.get('/entVisit/visitDetail', { params })

// 走访进度详情
export const processDetail = params => request.get('/entVisit/processDetail', { params })

// 企业处理走访
export const acceptVisit = params => request.post('/entVisit/acceptVisit', params)

// 企业评价
export const entEvaluate = params => request.post('/entVisit/entEvaluate', params)

// 删除走访/entVisit/delVisit
export const delVisit = params => request('/entVisit/delVisit', { params })

// 修改走访 /entVisit/editVisit
export const editVisit = params => request.post('/entVisit/editVisit', params)

// 发起人
export function commerType(val) {
  let initiator
  switch (val) {
    case 1:
      initiator = '企业发起'
      break
    case 2:
      initiator = '专员发起'
      break
  }
  return initiator
}

// 走访环节
export function commerStatus(val) {
  let link
  switch (val) {
    case 1:
      link = '待企业处理'
      break
    case 2:
      link = '待专员处理'
      break
    case 4:
      link = '专员拒绝邀请'
      break
    case 5:
      link = '企业拒绝走访'
      break
    case 6:
      link = '待专员上传记录'
      break
    case 7:
      link = '待企业评价'
      break
    case 8:
      link = '企业已评价'
      break
  }
  return link
}
